// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registerinput-details {
    display: flex;
    /* flex-direction: column; */
    flex-wrap: wrap;
    gap: 15px;
    margin: 10px;

}

.registerinput-detail {
    margin-top: 7px;
    display: flex;
    flex-direction: column;

    width: 48.8%;

    >label {
        margin: 5px 0;
        color: #202226;
        font-family: Poppins;
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        /* 171.429% */
    }

    input,
    select {
        border: none;
        border-radius: 8px;
        background-color: rgba(8, 119, 188, 0.09);
        height: 40px;
        padding: 0 10px;
        color: #404145;
        font-family: Poppins;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    >textarea {
        border: none;
        border-radius: 8px;
        background-color: rgba(8, 119, 188, 0.09);
        color: #404145;
        font-family: Poppins;
        font-size: 12px;
        font-style: normal;
        padding: 10px 10px;
        font-weight: 500;
        line-height: normal;
    }

    >input:focus-visible,
    >textarea:focus-visible,
    >select:focus-visible {
        outline: none;
    }

    >.focus {
        display: flex;
        justify-content: space-between;

        >button {
            color: var(--Primary-Color, #0877BC);
            font-family: Poppins;
            font-size: 12px;
            height: 30px;
            padding: 0 7px;
            margin-left: 10px;
            font-style: normal;
            font-weight: 400;
            border-radius: 4px;
            border: none;
            line-height: 24px;
            /* 200% */
            background-color: rgba(8, 119, 188, 0.09);
        }
    }
}

.registerinput-passwordfield {
    display: flex;
    justify-content: space-between;
    background-color: rgba(8, 119, 188, 0.09);
    border-radius: 6px;
    padding: 0 10px;

}

.registerinput-button {
    margin: 25px auto;
    height: 45px;
    color: #FFF;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    border: none;
    border-radius: 8px;
    width: 70%;
    background-color: #0877BC;
    cursor: pointer;
}

.registerinput-button:hover {
    opacity: 0.7;

}

@media(max-width: 768px) {
    .registerinput-detail {
        width: 100%;
    }

    .registerinput-details {
        gap: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Register.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,4BAA4B;IAC5B,eAAe;IACf,SAAS;IACT,YAAY;;AAEhB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;;IAEtB,YAAY;;IAEZ;QACI,aAAa;QACb,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,aAAa;IACjB;;IAEA;;QAEI,YAAY;QACZ,kBAAkB;QAClB,yCAAyC;QACzC,YAAY;QACZ,eAAe;QACf,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,yCAAyC;QACzC,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;;;QAGI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,8BAA8B;;QAE9B;YACI,oCAAoC;YACpC,oBAAoB;YACpB,eAAe;YACf,YAAY;YACZ,cAAc;YACd,iBAAiB;YACjB,kBAAkB;YAClB,gBAAgB;YAChB,kBAAkB;YAClB,YAAY;YACZ,iBAAiB;YACjB,SAAS;YACT,yCAAyC;QAC7C;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;;AAEnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;AACJ","sourcesContent":[".registerinput-details {\n    display: flex;\n    /* flex-direction: column; */\n    flex-wrap: wrap;\n    gap: 15px;\n    margin: 10px;\n\n}\n\n.registerinput-detail {\n    margin-top: 7px;\n    display: flex;\n    flex-direction: column;\n\n    width: 48.8%;\n\n    >label {\n        margin: 5px 0;\n        color: #202226;\n        font-family: Poppins;\n        font-size: 13px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n        /* 171.429% */\n    }\n\n    input,\n    select {\n        border: none;\n        border-radius: 8px;\n        background-color: rgba(8, 119, 188, 0.09);\n        height: 40px;\n        padding: 0 10px;\n        color: #404145;\n        font-family: Poppins;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n    }\n\n    >textarea {\n        border: none;\n        border-radius: 8px;\n        background-color: rgba(8, 119, 188, 0.09);\n        color: #404145;\n        font-family: Poppins;\n        font-size: 12px;\n        font-style: normal;\n        padding: 10px 10px;\n        font-weight: 500;\n        line-height: normal;\n    }\n\n    >input:focus-visible,\n    >textarea:focus-visible,\n    >select:focus-visible {\n        outline: none;\n    }\n\n    >.focus {\n        display: flex;\n        justify-content: space-between;\n\n        >button {\n            color: var(--Primary-Color, #0877BC);\n            font-family: Poppins;\n            font-size: 12px;\n            height: 30px;\n            padding: 0 7px;\n            margin-left: 10px;\n            font-style: normal;\n            font-weight: 400;\n            border-radius: 4px;\n            border: none;\n            line-height: 24px;\n            /* 200% */\n            background-color: rgba(8, 119, 188, 0.09);\n        }\n    }\n}\n\n.registerinput-passwordfield {\n    display: flex;\n    justify-content: space-between;\n    background-color: rgba(8, 119, 188, 0.09);\n    border-radius: 6px;\n    padding: 0 10px;\n\n}\n\n.registerinput-button {\n    margin: 25px auto;\n    height: 45px;\n    color: #FFF;\n    font-family: Poppins;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    border: none;\n    border-radius: 8px;\n    width: 70%;\n    background-color: #0877BC;\n    cursor: pointer;\n}\n\n.registerinput-button:hover {\n    opacity: 0.7;\n\n}\n\n@media(max-width: 768px) {\n    .registerinput-detail {\n        width: 100%;\n    }\n\n    .registerinput-details {\n        gap: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
